import { IconCalculator, IconLayoutSidebar } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { Link } from 'react-router-dom';

import { URLS } from 'services/urls';
import { FEATURE_IDS } from 'services/constants';
import { useSlideout } from 'contexts/BackOfEnvelopeContext';
import { NSButton } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { useAuthContext } from 'contexts/AuthContext';
import { config } from 'config';
import { NS_LOGO_URL } from 'constants/branding';
import useSideNavCollapsed from 'components/NSNavBarV2/context/SideNavCollapsedContext';
import { SIDE_NAV_TEST_IDS, TOP_NAV_V2_ICON_PARENT_CLASS } from 'components/NSNavBarV2/constants';
import UserMenu from './components/UserMenu/UserMenu';
import OrganizationMenu from './components/OrganizationMenu/OrganizationMenu';
import CannyChangelogWidget from './components/CannyChangelogWidget/CannyChangelogWidget';
import { DisplayedLogo } from './NSNavbar';
import './NSTopNavBarV2.scss';

const NSTopNavBarV2 = () => {
    const { userOrganizations, isLoadingUserOrganizations } = useAuthContext();
    const { toggleSlideout } = useSlideout();
    const { toggle: toggleSideNav } = useSideNavCollapsed();

    const organizations = userOrganizations.map(org => org.organization);
    const currentLogo = DisplayedLogo[config.environment] || NS_LOGO_URL;

    return (
        <nav className="NSTopNavBarV2">
            <div className="d-flex align-items-center NSTopNavBarV2__left">
                <Link to={URLS.DEALS.HOME} data-testid="home_url">
                    <img
                        src={currentLogo}
                        alt="Logo"
                        className="NSTopNavBarV2__logo"
                        id="nav-bar-logo"
                    />
                </Link>
                <span className={TOP_NAV_V2_ICON_PARENT_CLASS}>
                    <NSIcon
                        icon={IconLayoutSidebar}
                        onClick={toggleSideNav}
                        className="NSTopNavBarV2__nav-toggle cursor--pointer"
                        data-testid={SIDE_NAV_TEST_IDS.TOP_NAV_COLLAPSE_TOGGLE}
                    />
                </span>
                <RenderIf isTrue={organizations.length > 1 && !isLoadingUserOrganizations}>
                    <div className="d-flex align-items-stretch NSTopNavBarV2__org-menu">
                        <OrganizationMenu organizations={organizations} />
                    </div>
                </RenderIf>
            </div>
            <div className="d-flex align-items-center NSTopNavBarV2__right">
                <NSButton
                    id="back-of-envelope-nav-button"
                    icon={IconCalculator}
                    iconSize="lg"
                    color="secondary"
                    callback={toggleSlideout}
                    className="NSTopNavBarV2__assess-btn border-none NSButton--secondary-lighten text-nowrap"
                    featureId={FEATURE_IDS.BACK_OF_ENVELOPE}
                    ariaLabel="calculator"
                    allowReadOnlyAccess
                    tooltip="Assess deal financial feasibility with the Back-Of-Envelope calculator."
                >
                    <span className="ml-2">Assess feasibility</span>
                </NSButton>
                <CannyChangelogWidget />
                <UserMenu />
            </div>
        </nav>
    );
};

export default NSTopNavBarV2;
